// Import Core
import React, {useState} from 'react';
import styled from 'styled-components';
// Import Libraries
import GoogleMapReact from 'google-map-react';
// Import Icons
import mapMarker from '../../assets/images/mapMarker.svg';
import { Button } from "../ui/Button";

// https://github.com/google-map-react/google-map-react/blob/master/API.md

/* Styled Components */
const MapStyles = styled.div`
	height: 100%;
	width: 100%;
	.map {
		min-height: 328px;
		max-height: 350px;
		height: 350px;
		> div {
			min-height: inherit;
		}
	}

	h2 {
		margin-bottom: 40px;
	}
	.map_marker {
		margin-top: -37px;
		height: 37px;
		width: 29px;
	}

	.overlay {
		position: relative; 
	}
	.overlay::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #00000075;
		z-index: 2;
	}

	.overlay .display-button {
		z-index: 3;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%); 
		
	}
`;

// Pull in from Hotel
const defaultProps = {
	// center: {
	//   lat: 59.95,
	//   lng: 30.33,
	// },
	zoom: 13,
};

/* Components */
const AnyReactComponent = ({ marker }) => (
	<div>
		{/* ! FIX: Change to Static gastby image!!!! */}
		<img className='map_marker' src={marker} alt='Logo' />
	</div>
);

const DynamicMap = ({ lat, lng }) => (
  <GoogleMapReact
    bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_MAPS_API }}
    defaultCenter={{ lat, lng }}
    defaultZoom={defaultProps.zoom}
  >
    <AnyReactComponent lat={lat} lng={lng} marker={mapMarker} />
  </GoogleMapReact>
);

const EmbedMap = ({ lat, lng }) => (
  <img
    src={`https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=13&size=600x300&maptype=roadmap&markers=color:red%7C${lat},${lng}&key=${process.env.GATSBY_GOOGLE_MAPS_API}`}
    alt="Map with Marker"
    width="100%"
    height="100%"
    style={{ objectFit: "cover" }}
  />
);

const GoogleMap = ({ lat, lng }) => {
  const [interactiveMap, setInteractiveMap] = useState(false);

  return (
    <MapStyles>
      <h2>Location</h2>
      <div className={interactiveMap ? 'map' : 'map overlay'}>
        {interactiveMap ? (
          <DynamicMap lat={lat} lng={lng} />
        ) : (
			<EmbedMap lat={lat} lng={lng} />
        )}
		{!interactiveMap && <Button className='lightbox-btn display-button' onClick={()=>setInteractiveMap(true)}>Display Map</Button>}
      </div>
    </MapStyles>
  );
};

export default GoogleMap;
